import {BrowserRouter, Route, Routes} from "react-router-dom";
import {mainRoute} from "./routes";
import {Suspense} from "react";
import {ToastContainer} from "react-toastify";
import {AuthContextProvider} from "./context/AuthContext";
import Loading from "./components/Loading";
import SweetAlertContextProvider from "./context/sweetAlertContext";
import {ToggleSidebarContextProvider} from "./context/toggleSidebarContext";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {useEffect, useState} from "react";
const firebaseConfig = {
    apiKey: "YOUR_API_KEY",
    authDomain: "YOUR_AUTH_DOMAIN",
    projectId: "asretakhfifir-72634",
    storageBucket: "YOUR_STORAGE_BUCKET",
    messagingSenderId: "YOUR_MESSAGING_SENDER_ID",
    appId: "1:309053278225:web:950b479c659b62e78d89b0\n",
};
export default function App() {
    // useEffect(() => {
    //     const app = initializeApp(firebaseConfig);
    //     const analytics = getAnalytics(app);

    //     // You can use Firebase services, such as Firebase Authentication, Firestore, Realtime Database, etc., here.
    // }, []);
    return (
        <ToggleSidebarContextProvider>
            <AuthContextProvider>
                <SweetAlertContextProvider>
                    <Suspense fallback={<Loading/>}>
                        <BrowserRouter>
                            <Routes>
                                {
                                    mainRoute.map(route => {
                                        return <Route path={route.path} key={route.id}
                                                      element={<route.component/>}/>
                                    })
                                }
                            </Routes>
                            <ToastContainer
                                rtl={true}
                                theme="colored"
                            />
                        </BrowserRouter>
                    </Suspense>
                </SweetAlertContextProvider>
            </AuthContextProvider>
        </ToggleSidebarContextProvider>
    );
}
